import React from 'react';

const PricingTable: React.FC = () => {
  return (
    <>
      <div className='setting-table-conts' style={{ width: '100%' }}>
        <div className='setting-table-cont-sec'>
          <div className='view-history-head-frame'>
            <div className='view-history-head-frame-cell'>
              <div className='view-history-head-frame-cell-cont'>
                <div className='view-history-head-frame-cell-cont-text'>

                </div>
              </div>
            </div>
            <div className='view-history-head-frame-cell'>
              <div className='view-history-head-frame-cell-cont'>
                <div className='view-history-head-frame-cell-cont-text' style={{ fontSize: '14px', fontWeight: '600' }}>
                People & Companies
                </div>
              </div>
            </div>
            <div className='view-history-head-frame-cell'>
              <div className='view-history-head-frame-cell-cont'>
                <div className='view-history-head-frame-cell-cont-text' style={{ fontSize: '14px', fontWeight: '600' }}>
                Products & HTS Codes
                </div>
              </div>
            </div>
            <div className='view-history-head-frame-cell'>
              <div className='view-history-head-frame-cell-cont'>
                <div className='view-history-head-frame-cell-cont-text' style={{ fontSize: '14px', fontWeight: '600' }}>
                Documents
                </div>
              </div>
            </div>
          </div>
          <div className='settings-table-frame'>
            <div className='settings-table-frame-row' style={{ height: '36px' }}>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts'>Monthly Volume</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts'>Price Per Call</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts'>Price Per Call</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-texts'>Price Per Call</div>
              </div>
            </div>
            <div className='settings-table-frame-row' style={{ height: '36px' }}>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>First 99</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>Free</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>Free</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>Free</div>
              </div>
            </div>
            <div className='settings-table-frame-row' style={{ height: '36px' }}>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>100 - 9,999</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.12/ Call</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.25/ Call</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.70/ Call</div>
              </div>
            </div>
            <div className='settings-table-frame-row' style={{ height: '36px' }}>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>10,000 - 49,999</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.09/ Call</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.15/ Call</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.50/ Call</div>
              </div>
            </div>
            <div className='settings-table-frame-row' style={{ height: '36px' }}>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>50,000 - 74,999</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.05/ Call</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.11/ Call</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.20/ Call</div>
              </div>
            </div>
            <div className='settings-table-frame-row' style={{ height: '36px' }}>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>75,000 - 100,000</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.03/ Call</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.05/ Call</div>
              </div>
              <div className='settings-table-frame-row-cell1'>
                <div className='settings-table-frame-row-cell1-text'>$0.10/ Call</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PricingTable;
